/* eslint no-param-reassign: ["off"] */
/* eslint-disable no-sequences, no-shadow, no-unused-expressions */
import { gsap } from 'gsap/all';

import Draggable from 'gsap/Draggable';
import { InertiaPlugin } from '../gsap-bonus/InertiaPlugin';

gsap.registerPlugin(Draggable, InertiaPlugin);

export default class Slides {
    constructor(instance) {
        this.state = {
            hasActiveItem: true,
            activeProjectIndex: 0,
        };

        this.disableVerticalScroll = false;
        this.instance = instance;
        this.killed = false;

        this.wheelTracker = {
            active: false,
            x: 0,
        };

        this.keyboardTracker = {
            sourceIndex: 0,
            targetIndex: 0,
        };

        EventBus.$once('page-transition-leave', () => {
            this.killed = true;
            this.killCarousel();
        });

        this.initializeCarousel = () => {
            this.draggableDiv = document.createElement('div');
            const slides = [...document.querySelectorAll('.slide')];

            this.items = slides.map((item, index) => {
                const box = item.getBoundingClientRect();
                const span = item.querySelector('h1');
                console.log(index);
                console.log(span.offsetWidth);
                // item.children[0].style.width = span.width + 'px';
                // const number = item.querySelector('.slide__chapter-number').getBoundingClientRect();
                // const scaleFactor = 0.8;
                // const scaleDifference = number.width - (number.width * scaleFactor);
                // const lineTranslate = scaleDifference / 2;

                // console.log(`Index: ${index}`);
                // console.log(`Normal width: ${number.width}`);
                // console.log(`Scaled width: ${number.width * scaleFactor}`);
                // console.log(`Scale difference: ${scaleDifference}`);
                // console.log(`Linetranslate: ${lineTranslate}`);

                return {
                    el: item,
                    width: box.width,
                    height: box.height,
                    // lineTranslate,
                };
            });

            this.sizes = this.items.reduce((t, e) => ({
                totalWidth: t.totalWidth + e.width,
                maxItemWidth: Math.max(t.maxItemWidth, e.width),
                maxItemHeight: Math.max(t.maxItemHeight, e.height),
            }), {
                totalWidth: 0,
                maxItemWidth: 0,
                maxItemHeight: 0,
            });
            const { totalWidth, maxItemWidth, maxItemHeight } = this.sizes;

            this.xModifier = (tick, context) => {
                const {
                    totalWidth: timeout,
                    maxItemWidth: defaultLeft,
                } = this.sizes;
                // TODO: Fix hidden calculation.
                const HIDDEN = tick - context.width <= window.innerWidth + defaultLeft ? 'visible' : 'hidden';
                const x = parseFloat(tick) % timeout;
                gsap.set(context.el, {
                    x,
                    visibility: 'visible',
                });

                return tick;
            };

            let i = 0;
            this.items.forEach((item) => {
                item.xCenter = maxItemWidth + (window.innerWidth - item.width) / 2 - i;
                i += item.width;
            });

            gsap.set('.slides-inner', {
                x: -maxItemWidth,
                height: '100vh',
                yPercent: -50,
                visibility: 'visible',
            });

            this.animation = gsap.to(this.items, {
                duration: 5,
                x: `+=${totalWidth}`,
                ease: 'none',
                paused: true,
                repeat: -1,
                modifiers: {
                    // x: this.xModifier
                    x: (value, item) => {
                        const HIDDEN = item.width <= window.innerWidth + this.sizes.maxItemWidth ? 'visible' : 'hidden';
                        const x = parseFloat(value) % totalWidth;
                        gsap.set(item.el, {
                            x,
                            visibility: HIDDEN,
                        });

                        return value;
                    },
                },
            });

            const isMobile = document.documentElement.classList.contains('touchevents');

            this.draggable = Draggable.create(this.draggableDiv, {
                type: 'x',
                inertia: true,
                maxDuration: 1,
                dragClickables: false,
                snap: {
                    x: this.snap,
                },
                trigger: '.slides',
                onPress: this.handleDraggablePress,
                onRelease: this.handleDraggableRelease,
                onClick: this.handleDraggableClick,
                onDragStart: this.handleDraggableDragStart,
                onDrag: this.handleDraggableDrag,
                onThrowUpdate: this.handleDraggableThrowUpdate,
                onThrowComplete: this.handleDraggableThrowComplete,
                // allowEventDefault: !isMobile,
                // allowNativeTouchScrolling: !isMobile,
                // allowContextMenu: true,
                // dragClickables: true,
            });

            this.initialProjectIndex = this.state.activeProjectIndex;

            let activeCenter = this.items[this.state.activeProjectIndex].xCenter;
            this.items.forEach((item) => {
                item.x = this.xModifier(activeCenter, item);
                activeCenter += item.width;
            });
        };

        this.snap = (t) => {
            const initialCenter = this.items[this.initialProjectIndex].xCenter;
            const r = t + initialCenter;
            const n = this.items[0];
            const i = this.items[this.items.length - 1];
            const a = n.xCenter + n.width / 2;
            const o = i.xCenter - i.width / 2;

            let s = 0;
            if (r > a) { for (; r + s > a;) s -= this.sizes.totalWidth; } else if (r < o) { for (; r + s < o;) s += this.sizes.totalWidth; }
            const c = r + s;
            const h = this.items.findIndex((t) => t.xCenter - t.width / 2 < c && t.xCenter + t.width / 2 > c);
            this.state = {
                hasActiveItem: !0,
                activeProjectIndex: h,
            };

            this.indexChange(h);
            // const l = this.props.projects[h];
            // return this.context.showWorkImage(l.image.file.url),
            return this.items[h].xCenter - s - initialCenter;
        };

        this.indexChange = (index) => {
            window.requestAnimationFrame(() => {
                this.instance.setActiveIndex(index);
                this.onActiveProjectIndexChange(index);
            });
        };

        this.handleDraggablePress = () => {
            if (this.onDraggablePress) {
                this.onDraggablePress();
            }
            this.initProgress(),
            this.wheelThrow && this.wheelThrow.isActive() && this.wheelThrow.pause();
        };

        this.handleDraggableRelease = () => {
            if (this.onDraggablePress) {
                this.onDraggableRelease();
            }
        };

        this.handleDraggableClick = () => {
            this.wheelThrow && this.wheelThrow.paused() && this.wheelThrow.isActive() && this.wheelThrow.resume();
        };

        this.handleDraggableDragStart = () => {
            this.state.hasActiveItem = !1;
            this.wheelThrow && this.wheelThrow.kill();
        };

        this.handleDraggableDrag = () => {
            this.updateProgress();
        };

        this.handleDraggableThrowUpdate = () => {
            this.updateProgress();
        };

        this.handleDraggableThrowComplete = () => {

            // this.props.onSnap && this.props.onSnap(this.state.activeProjectIndex)
        };

        this.handleWheel = (t) => {
            const e = 'isEnd' in t;
            const r = this.disableVerticalScroll && !e ? 0 : 1;
            this.wheelThrow && this.wheelThrow.kill(),
            this.wheelTracker.active || (this.wheelTracker.active = !0,
            this.initProgress()),
            this.wheelTracker.x -= t.deltaX + t.deltaY * r,
            this.wheelUpdate();
        };

        this.handleWheelInertia = () => {
            const t = {
                inertia: {
                    x: {
                        end: this.snap,
                    },
                    duration: {
                        min: 0.1,
                        max: 1,
                    },
                },
                onUpdate: this.wheelUpdate,
                onComplete: this.wheelComplete,
            };
            this.wheelThrow = gsap.to(this.wheelTracker, t);
            this.wheelTracker.active = false;
        };

        this.wheelUpdate = () => {
            gsap.set(this.draggableDiv, {
                x: this.wheelTracker.x,
            });
            this.draggable[0].update();
            this.updateProgress();
        };

        this.wheelComplete = () => {
            // this.props.onSnap && this.props.onSnap(this.state.activeProjectIndex);
        };

        this.setLineTranslate = () => {

        };

        this.navigate = (target) => {
            const { activeProjectIndex } = this.state;
            if (this.navigateTween && this.navigateTween.isActive()) {
                // this.keyboardTracker.targetIndex += activeProjectIndex;

            } else {
                this.keyboardTracker.sourceIndex = activeProjectIndex;
                this.keyboardTracker.targetIndex = activeProjectIndex + target;
                if (this.keyboardTracker.targetIndex < 0) {
                    this.keyboardTracker.targetIndex = this.items.length - 1;
                }

                if (this.keyboardTracker.targetIndex === this.items.length) {
                    this.keyboardTracker.targetIndex = 0;
                }
                this.initProgress();
                this.state.hasActiveItem = false;
            }

            const tracker = this.keyboardTracker;
            // const i = tracker.targetIndex;
            const direction = tracker.targetIndex - tracker.sourceIndex > 0 ? 1 : -1;
            const total = Math.abs(tracker.targetIndex - tracker.sourceIndex);
            console.log(total);
            let xValue = 0;
            let index = 0;
            let currentIndex = tracker.sourceIndex;
            for (; index <= total; index++, currentIndex += direction) {
                // const translate = currentIndex === tracker.sourceIndex || currentIndex === tracker.targetIndex ? .5 : 1;
                let translate = 0;
                translate = (this.items[tracker.sourceIndex].width / 2) + (this.items[tracker.targetIndex].width / 2);

                // xValue += this.items[tracker.targetIndex].width * translate * direction;
                xValue = translate * target;
                console.log(xValue);
            }

            const activeIndex = tracker.targetIndex;
            this.state = {
                hasActiveItem: true,
                activeProjectIndex: activeIndex,
            };
            this.navigateTween = gsap.to(this.draggableDiv, {
                duration: 0.5,
                x: this.xMin - xValue,
                onUpdate: () => {
                    this.draggable[0].update();
                    this.updateProgress();
                },
                onStart: () => {
                    const timeline = gsap.timeline();
                    timeline.to('.slide.show-meta a', 0, { opacity: 0 }, 0);
                    // timeline.to('.slide.show-meta .slider__pagination-holder', 0, { opacity: 0 }, 0);
                    // timeline.to('.slide h1', 0.4, { z: -200, ease: 'power4.easeOut' }, 0);

                    gsap.to('.slider__pagination', 0.3, { autoAlpha: 0, ease: 'power4.easeOut' });
                    gsap.to('.slider__pagination-divider', 0.3, { scaleX: 0, transformOrigin: 'center center ', ease: 'power4.easeOut' });
                    this.onActiveProjectIndexChange(activeIndex);
                    this.indexChange(activeIndex);
                },
                onComplete: () => {
                    // this.onActiveProjectIndexChange(activeIndex);
                    // this.snap(activeIndex);

                    const timeline = gsap.timeline();
                    timeline.to('.slide.show-meta a', 0, { opacity: 1 }, 0);
                    // timeline.to('.slide.show-meta .slider__pagination-holder', 0, { opacity: 1 }, 0);
                    // timeline.to('.slide h1', 0.4, { z: 0, ease: 'power4.easeOut' }, 0);

                    gsap.to('.slide.show-meta .slider__pagination', 0.3, { autoAlpha: 1, ease: 'power4.easeOut' });
                    gsap.to('.slide.show-meta .slider__pagination-divider', 0.3, { scaleX: 1, transformOrigin: 'center center ', ease: 'power4.easeOut' });
                },
            });
        };

        this.initProgress = () => {
            // this.animation.play();
            const { totalWidth: t } = this.sizes;
            this.xMin = this.draggable[0].x;
            this.xMax = this.xMin + t;
            this.progress = this.animation.progress();
            this.wheelTracker.x = this.draggable[0].x;
        };

        this.initializeCarousel();
        window.addEventListener('resize', this.handleResize.bind(this));
    }

    updateProgress() {
        const normalized = this.normalize(this.draggable[0].x);
        const normalizedProgress = this.progress + normalized;

        this.animation.progress(normalizedProgress > 0 ? normalizedProgress : normalizedProgress + 1);
    }

    normalize(t) {
        return (t - this.xMin) / (this.xMax - this.xMin);
    }

    killCarousel() {
        window.removeEventListener('resize', this.handleResize.bind(this));

        if (this.animation) {
            this.animation.kill();
        }

        if (this.draggable) {
            this.draggable[0].kill();
        }

        if (this.wheelThrow) {
            this.wheelThrow.kill();
        }

        if (this.navigateTween) {
            this.animation.kill();
        }
        // u.a.untrack(this.wheelTracker);
    }

    handleResize() {
        this.killCarousel();

        if (this.killed) {
            window.removeEventListener('resize', this.handleResize.bind(this));
            return;
        }

        this.initializeCarousel();
    }
}
